import type { DefinitionNode, DocumentNode, OperationDefinitionNode } from 'graphql';

const QUERY_NAME_MATCHER = /query\s+(\w+).*?\{/;

export const UNEXPECTED_RESPONSE = { data: null, hasErrors: false };

function isOperationDefinition(definition: DefinitionNode): definition is OperationDefinitionNode {
	return definition.kind === 'OperationDefinition';
}

export function getOperationName(query: string | DocumentNode): string | null | undefined {
	if (typeof query === 'string') {
		const match = query.match(QUERY_NAME_MATCHER);
		if (match) return match[1];
	} else {
		// GraphQL document AST:
		for (const definition of query.definitions || []) {
			if (isOperationDefinition(definition) && definition.name) {
				return definition.name.value;
			}
		}
	}

	return undefined;
}
